import { Component, TemplateRef, ViewChild } from '@angular/core';
import { CtButtonConfiguration, CtModelConfiguration, CtModelDatatableOperators, CtModelOperator, CtModelService, MAT_RAISED_PRIMARY } from '@ctsolution/ct-framework';
import { WorkOrderPaymentRouteData } from '../../../_core/route-data/work-order-payment.route-data';
import { CTMGeneralService } from '../../../_core/lib/general.service';
import { Router } from '@angular/router';
import { DEFAULT_DATATABLE_CONFIGURATION } from '../../../_core/constants';
import { CTConfigurationModel } from 'projects/ct-manager/src/app/_core/classes/ct-configuration-model';
import { CtManagerService } from '../../../_core/lib/ct-manager.service';

@Component({
  selector: 'app-payments-list',
  templateUrl: './payments-list.component.html',
  styleUrls: ['./payments-list.component.scss']
})
export class PaymentsListComponent {

  exportDownloadAttachmentButton: CtButtonConfiguration = CtButtonConfiguration
    .create()
    .setAction(() => this.downloadExcel())
    .setLabel("Esporta")
    .setMatherialOptions(MAT_RAISED_PRIMARY)
    .setIcon("download");

    @ViewChild("legendTemplate") legendTemplate: TemplateRef<any> | null = null;

    paymentConfiguration: CTConfigurationModel = CTConfigurationModel.create().setVisible(false);

  

  configuration: CtModelConfiguration<PaymentsListComponent> = CtModelConfiguration
    .create<PaymentsListComponent>()
    .setRouteData(WorkOrderPaymentRouteData())
    .setOperations([CtModelOperator.Update,CtModelOperator.Detail])
    .setCTDatatableConfiguration(DEFAULT_DATATABLE_CONFIGURATION())
    .setOnEdit(event =>  this.general.navigateOnCTModelRouter(["payments"], "edit", {
      value: event,
      configuration: this.configuration!
    }))
    .setOnDetail(event => this.router.navigate(["work-order", "edit", event.WorkOrder.Oid!.toString()]));


  constructor(private general: CTMGeneralService, private router: Router, private modelService : CtModelService<PaymentsListComponent>, private managerService : CtManagerService) {
  }

  async ngOnInit() {

    await this.managerService.getComponentOverride("payments", "paymentConfiguration", this.paymentConfiguration).then((component) => {
      return;
    });

  }

  ngAfterViewInit(): void {

    this.setup()

  }


  setup() {

    this.configuration.setLegendTemplate(this.legendTemplate);

    this.configuration
      .initialized()
      .subscribe(() => this.configuration?.setOperations([CtModelOperator.Update,CtModelOperator.Detail]));
  }

  downloadExcel(){

    const body : CtModelDatatableOperators = CtModelDatatableOperators.create().setPagination(null);

    this.modelService.export(this.configuration, body, { action: 'ExportExcelWorkOrderPayment' })

  }
}
